import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { Image, Paragraph } from '@zillow/constellation';

import AnalyticsConstants from 'app/shared/constants/AnalyticsConstants';
import analyticsUtils from 'app/client/utils/analyticsUtils';

import WizardBodyTemplate from 'app/shared/components/WizardBodyTemplate';
import WizardActionFooter from 'app/shared/components/WizardActionFooter';
import HomeSearch from 'app/shared/images/HomeSearch.svg';

const propTypes = {
    onGoToPrevStep: PropTypes.func.isRequired,
    onGoToNextStep: PropTypes.func.isRequired,
    progressStepper: PropTypes.node.isRequired,
};

const defaultProps = {};

const WizFindListingSuccess = ({
    onGoToNextStep,
    onGoToPrevStep,
    progressStepper,
}) => {
    const dispatch = useDispatch();
    const handleClickPrevStep = () => {
        dispatch(analyticsUtils.track.GAEventV2(
            AnalyticsConstants.GA_EVENTS.CLAIM_LISTINGS_CLICK_BACK,
            { label: AnalyticsConstants.CLAIM_LISTINGS_LABEL.LISTING_LOOKUP_SUCCESS },
        ));
        onGoToPrevStep();
    };

    const handleClickNextStep = () => {
        dispatch(analyticsUtils.track.GAEventV2(
            AnalyticsConstants.GA_EVENTS.CLAIM_LISTINGS_CLICK_NEXT,
            { label: AnalyticsConstants.CLAIM_LISTINGS_LABEL.LISTING_LOOKUP_SUCCESS },
        ));
        onGoToNextStep();
    };

    const renderSubtitle = () => (
        <>
            <Paragraph marginBottom="md">
                For security purposes, we will verify the contact information on your listings before allowing them to
                be transferred to Zillow Rental Manager.
            </Paragraph>
            <Paragraph>
                To ensure all your listings are found, please verify all phone numbers and email addresses you may have
                used.
            </Paragraph>
        </>
    );

    return (
        <WizardBodyTemplate
            title="Next, let's verify your contact information"
            subtitle={renderSubtitle()}
            icon={<Image src={HomeSearch} alt="HomeSearch" />}
            progressStepper={progressStepper}
            footer={(
                <WizardActionFooter
                    onBackClick={handleClickPrevStep}
                    onNextClick={handleClickNextStep}
                    isBackDisabled={!onGoToPrevStep}
                    isNextDisabled={!onGoToNextStep}
                />
            )}
        />
    );
};

WizFindListingSuccess.propTypes = propTypes;
WizFindListingSuccess.defaultProps = defaultProps;

export default WizFindListingSuccess;
